module.exports = __webpack_public_path__ + "img/1648054797_23-kartinkin-net-p-kartinki-voprosa-24 1.82612b87.png";